/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { Button, Icon } from 'learning-panel-components';
import { FC } from 'react';
import { getPlatformUrl } from 'utils';
import { translate } from 'translations';
import styles from './learningPathBanner.module.scss';

const LearningPathBanner: FC<LearningPathBannerProps> = (props: LearningPathBannerProps) => {
    const { name, description, status, uuid, duration } = props;

    return (
        <div>
            <div className={styles['learning-path-banner']}>
                <div className={styles['inner-wrapper']}>
                    <div className={styles.tag}>{translate(status === 'notStarted' ? 'StartNow' : 'Resume')}</div>
                    <div className={styles['flags-background']}></div>
                    <div className={styles['right-background']}></div>
                    <div className={styles['left-side']}>
                        <div className={styles['top-wrapper']}>
                            <Icon name={'path'} />
                            <div className={styles.text}>
                                {translate('learningPathAbout_X_minutes', { minutes: String(duration) })}
                            </div>
                        </div>
                        <div className={styles['name-wrapper']}>
                            <div className={styles.name} title={translate(name)}>
                                {translate(name)}
                            </div>
                        </div>
                        <div className={styles.description} title={translate(description)}>
                            {translate(description)}
                        </div>
                        <div>
                            <div className={styles['button-wrapper']}>
                                <a href={`${getPlatformUrl()}/app/learningPath?uuid=${uuid}`}>
                                    <Button
                                        type="bigGradient"
                                        text={translate(status === 'notStarted' ? 'BeginJourney' : 'Continue')}
                                        className={styles.button}
                                        lowerCase
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export interface LearningPathBannerProps {
    name: string;
    description: string;
    duration: number;
    uuid: string;
    status: 'inProgress' | 'completed' | 'notStarted';
}

export default LearningPathBanner;
